<template>

    <div>
        <div v-if="noBilledPorts" class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 px-4 py-3 mb-4" role="alert">
            <p class="sau-font sm mb-0">This service has no billed ports, which may indicate that its usage is measured by another service on your account such as Pooled Data or a Firewall.</p>
        </div>
        <!-- Flag :link as false to hide the 'View Network Usage' link (this page). Same component is used on the status page -->
        <sau-bandwidth-graph :service="service" :link="false"></sau-bandwidth-graph>

        <sau-daily-usage-graph v-if="showDaily" class="pb-12" :service="service"></sau-daily-usage-graph>

        <sau-port-graphs v-if="showPorts" @no-billed-ports="noBilledPorts = true"></sau-port-graphs>

    </div>
</template>

<script>
export default {
    props: ['service'],
    data() {
        return {
            showPorts: false,
            noBilledPorts: false,
        }
    },
    created() {
        /** Only show ports for Dedicated Servers & Colocation services */
        switch(this.getServiceType()) {
            case 'dedicated-server':
            case 'colocation':
            case 'transit':
                this.showPorts = true;
                    break
            default:
                this.showPorts = false;
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>
